import "./Home.module.css";
import Navigation from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import LuxuryHeroBanner from "./sections/LuxuryHeroBanner";
import CategoryCards from "./sections/CategoryCards";
import NewArrivals from "./sections/NewArrivals";
import Bestsellers from "./sections/Bestsellers";
import FeaturedCollection from "./sections/FeaturedCollection";
import ExclusiveCollectionBanner from "./sections/ExclusiveCollectionBanner";
import Whyshopwithlush from "./sections/Whyshopwithlush";
import Testimonials from "./sections/Testimonials";
import Instagramsocialfeed from "./sections/Instagramsocialfeed";
import ExclusiveOfferHero from "./sections/ExclusiveOfferHero";
import Newsletter from "./sections/Newsletter";
export default function HomePage() {
  return <div>
      <Navigation />
      <LuxuryHeroBanner />
      <CategoryCards />
      <NewArrivals />
      <Bestsellers />
      <FeaturedCollection />
      <ExclusiveCollectionBanner />
      <Whyshopwithlush />
      <Testimonials />
      <Instagramsocialfeed />
      <ExclusiveOfferHero />
      <Newsletter />
      <Footer />
    </div>;
}